// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__k1iL1","text":"style_text__bxeya","actions":"style_actions__omHE1","actions_btn":"style_actions_btn__QlyVC"};